"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const browser_condition_value_1 = require("./segment-technologies/browser-condition.value");
const custom_variable_condition_value_1 = require("./segment-common/custom-variable-condition.value");
const event_stream_click_condition_value_1 = require("./segment-behaviors/event-stream-click-condition.value");
const exit_page_condition_value_1 = require("./segment-behaviors/exit-page-condition.value");
const geographic_area_condition_value_1 = require("./segment-common/geographic-area-condition.value");
const goal_condition_value_1 = require("./segment-behaviors/goal-condition.value");
const is_returning_condition_value_1 = require("./segment-common/is-returning-condition.value");
const landing_path_condition_value_1 = require("./segment-behaviors/landing-path-condition.value");
const language_condition_value_1 = require("./segment-common/language-condition.value");
const number_pageviews_condition_value_1 = require("./segment-behaviors/number-pageviews-condition.value");
const number_visits_condition_value_1 = require("./segment-common/number-visits-condition.value");
const os_version_condition_value_1 = require("./segment-technologies/os-version-condition.value");
const page_viewed_condition_value_1 = require("./segment-behaviors/page-viewed-condition.value");
const referrer_condition_value_1 = require("./segment-common/referrer-condition.value");
const resolution_condition_value_1 = require("./segment-technologies/resolution-condition.value");
const transaction_condition_value_1 = require("./segment-behaviors/transaction-condition.value");
const visit_duration_condition_value_1 = require("./segment-behaviors/visit-duration-condition.value");
const text_seen_condition_value_1 = require("./segment-common/text-seen-condition.value");
exports.webSegmentConditions = [
    browser_condition_value_1.browserCondition,
    resolution_condition_value_1.resolutionCondition,
    custom_variable_condition_value_1.customerVariableCondition,
    event_stream_click_condition_value_1.eventStreamClickCondition,
    exit_page_condition_value_1.exitPageCondition,
    geographic_area_condition_value_1.geographicAreaCondition,
    goal_condition_value_1.goalCondition,
    is_returning_condition_value_1.isReturningCondition,
    language_condition_value_1.languageCondition,
    landing_path_condition_value_1.landingPathCondition,
    number_visits_condition_value_1.numberVisitsCondition,
    number_pageviews_condition_value_1.numberPageviewsCondition,
    os_version_condition_value_1.osVersionCondition,
    page_viewed_condition_value_1.pageViewedCondition,
    referrer_condition_value_1.referrerCondition,
    transaction_condition_value_1.transactionCondition,
    text_seen_condition_value_1.textSeenCondition,
    visit_duration_condition_value_1.visitDurationCondition,
];
//# sourceMappingURL=index.js.map